<div class="insights-div">
  @for (item of insights.components; track item; let itemIdx = $index) {
    @if (!item.isSymbol) {
      <div  class="insight-component">
        <app-period-over-period
        [ngClass]="{
          'selected-insight': selectedItem === itemIdx,
          'deselected-insight': selectedItem !== itemIdx && selectedItem !== -1 && itemIdx > 0,
          'calculated-insight': selectedItem === -1 && !item.isRaw && itemIdx > 0,
          'raw-insight': item.isRaw || itemIdx === 0
        }"
          style="display: inline-block"
          [label]="item.label"
          [value]="item.value"
          [prevValue]="item.prevValue"
          [rawItem]="item.isRaw"
          [ref]="item.ref"
          [footnotes]="item.footnotes"
          [prevSourceBox]="item.prevSourceBox"
          [sourceBox]="item.sourceBox"
          [textFormat]="item?.textFormat"
          [currency]="currency"
          (openDetail)="insightDetailSelected($event, itemIdx)"
          (openFootnotes)=lineItemFootnoteSelected($event)
          (openSourceBox)="lineItemSourceBoxSelected($event)"
        ></app-period-over-period>
      </div>
    }
    @if (item.isSymbol) {
      <div class="insight-component">
        <div class="equation-symbol-span">{{ item.label }}</div>
      </div>
    }
  }
</div>

